import Input from "@storeblocks/input";
import styled from "styled-components";

export const StyledStoreblocksInput = styled(Input)`
  max-width: 100%;

  & > div {
    max-width: 100%;
  }
`;
